import router from '@/router'
import store from '@/store'

const whiteList = ['/cart', '/mine']
router.beforeEach(async(to, from, next) => {

  // determine whether the user has logged in
  const hasToken = localStorage.getItem('Authorization')
  // console.log('to:', to)
  // console.log('from:', from)
  // console.log('path:', whiteList.indexOf(to.path))
  if (to.path.indexOf('business') > -1) {
    var storeInfo = localStorage.getItem('storeInfo')
    if (storeInfo == null) {
      if (to.path.indexOf('supplierLogin') < 0) {
        location.href = '/business/supplierLogin'
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    var openid = localStorage.getItem('openid')
    if (openid === null) {
      if (hasToken) {
        if (whiteList.indexOf(to.path) < 0) {
          next()
        } else {
          // 获取用户信息
          const hasGetUserInfo = store.getters.id
          if (hasGetUserInfo) {
            next()
          } else {
            try {
              // get user info
              await store.dispatch('GetUserInfo')
              next()
            } catch (error) {
              // 清除用户信息，退出登录，跳转登录页
              store.dispatch('FedLogOut')
              //Notify.error(error || 'Has Error')
              next(`/login`)
            }
          }
        }
      } else {
        /* has no token */
        console.log('has no token:', whiteList.indexOf(to.path))
        if (whiteList.indexOf(to.path) !== -1) {
          // 获取用户信息
          const hasGetUserInfo = store.getters.id
          if (hasGetUserInfo) {
            next()
          } else {
            next('/login')
          }
        } else {
          // other pages that do not have permission to access are redirected to the login page.
          next()
        }
      }
    } else {
      next()
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/permission.js